// Group GROUP 9. Questions and Tags
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group9Data = {
  "id": "group_9",
  "title": {
    "tc": "疑問與附加構式",
    "sc": "疑问与附加构式",
    "en": "Questions and Tags"
  },
  "subtitle": {
    "tc": "Questions and Tags",
    "sc": "Questions and Tags",
    "en": "Questions and Tags"
  },
  "icon": "❓",
  "difficulty": "intermediate",
  "color": "from-pink-500 to-pink-600",
  "topics": [
    {
      "id": "wh_as_subject",
      "title": {
        "tc": "疑問詞作主語",
        "sc": "疑问词作主语",
        "en": "Wh- as Subject"
      },
      "description": {
        "tc": "學習疑問詞作為主語的用法",
        "sc": "学习疑问词作为主语的用法",
        "en": "Learn the usage of Wh- words as subjects"
      },
      "icon": "👤",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "wh_subj_1",
          "sentence": "Who broke the vase?",
          "analysis": "Who (S) broke (V) the vase (O)?",
          "translation": {
            "tc": "誰打破了花瓶？",
            "sc": "谁打破了花瓶？",
            "en": "Who broke the vase?"
          }
        },
        {
          "id": "wh_subj_2",
          "sentence": "What caused the delay?",
          "analysis": "What (S) caused (V) the delay (O)?",
          "translation": {
            "tc": "什麼造成了延遲？",
            "sc": "什么造成了延迟？",
            "en": "What caused the delay?"
          }
        },
        {
          "id": "wh_subj_3",
          "sentence": "Which comes first?",
          "analysis": "Which (S) comes (V) first (M)?",
          "translation": {
            "tc": "哪個先來？",
            "sc": "哪个先来？",
            "en": "Which comes first?"
          }
        },
        {
          "id": "wh_subj_4",
          "sentence": "Who wants coffee?",
          "analysis": "Who (S) wants (V) coffee (O)?",
          "translation": {
            "tc": "誰想要咖啡？",
            "sc": "谁想要咖啡？",
            "en": "Who wants coffee?"
          }
        },
        {
          "id": "wh_subj_5",
          "sentence": "What happened yesterday?",
          "analysis": "What (S) happened (V) yesterday (M)?",
          "translation": {
            "tc": "昨天發生了什麼？",
            "sc": "昨天发生了什么？",
            "en": "What happened yesterday?"
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：Wh- 作主語時不倒裝；動詞依單複一致。",
        "sc": "要点：Wh- 作主语时不倒装；动词依单复数一致。",
        "en": "Key points: Wh- as subject does not trigger inversion; verb agrees with number."
      }
    },
    {
      "id": "do_support",
      "title": {
        "tc": "do-support 助動詞支持",
        "sc": "do-support 助动词支持",
        "en": "Do-support"
      },
      "description": {
        "tc": "學習 do-support 的用法",
        "sc": "学习 do-support 的用法",
        "en": "Learn the usage of do-support"
      },
      "icon": "🔧",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "do_sup_1",
          "sentence": "Why did you leave?",
          "analysis": "Why (Wh) did (Aux) you (S) leave (V)?",
          "translation": {
            "tc": "你為什麼離開？",
            "sc": "你为什么离开？",
            "en": "Why did you leave?"
          }
        },
        {
          "id": "do_sup_2",
          "sentence": "Where do they work?",
          "analysis": "Where (Wh) do (Aux) they (S) work (V)?",
          "translation": {
            "tc": "他們在哪裡工作？",
            "sc": "他们在哪里工作？",
            "en": "Where do they work?"
          }
        },
        {
          "id": "do_sup_3",
          "sentence": "When did it start?",
          "analysis": "When (Wh) did (Aux) it (S) start (V)?",
          "translation": {
            "tc": "它什麼時候開始的？",
            "sc": "它什么时候开始的？",
            "en": "When did it start?"
          }
        },
        {
          "id": "do_sup_4",
          "sentence": "How do you know?",
          "analysis": "How (Wh) do (Aux) you (S) know (V)?",
          "translation": {
            "tc": "你怎麼知道？",
            "sc": "你怎么知道？",
            "en": "How do you know?"
          }
        },
        {
          "id": "do_sup_5",
          "sentence": "What did she buy?",
          "analysis": "What (Wh) did (Aux) she (S) buy (V)?",
          "translation": {
            "tc": "她買了什麼？",
            "sc": "她买了什么？",
            "en": "What did she buy?"
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：一般動詞問句需 do/does/did；be/情態例外。",
        "sc": "要点：一般动词问句需 do/does/did；be/情态例外。",
        "en": "Key points: main verb questions need do/does/did; be/modals are exceptions."
      }
    }
  ]
};
